export default __webpack_public_path__ + "media/blackberries-small.8de5afd54e02924ebb20092a53221996.webp";